module.exports = __webpack_public_path__ + "img/sight_normal.72174343.png";